import { useCallback } from 'react';

import { RootState } from 'store/store';
import { useAppDispatch, useAppStore } from 'store/store-hooks';
import { getClipTime, selectClipData } from 'components/app/_helpers/_app.helper';
import { passFileAccessedAt } from 'components/app/_mediator/app-files.slice';
import { setSelectedFile } from 'components/app/projects/_mediator/projects.slice';
import { setActiveClip } from 'components/app/editor/_mediator/editor.slice';
import { useSelectorContext } from './selector.provider';

export const useSelectorCb = () => {
  const { srPlayerRef, srListenClip } = useSelectorContext();
  const dispatch = useAppDispatch();
  const store = useAppStore();

  const srSelectFile = useCallback((fileId: FileId) => {
    const { selector } = selectData(store.getState());
    dispatch(passFileAccessedAt(fileId));
    dispatch(setSelectedFile(fileId));
    dispatch(setActiveClip(selector?.[fileId][0] ?? null));
  }, []);

  const srSelectClip = useCallback((clipId: CellClip) => {
    srListenClip.current = clipId;
    if (clipId) srSeekToClip(clipId);
    dispatch(setActiveClip(clipId));
  }, []);

  const srSeekToClip = useCallback((clipId: ClipId) => {
    const { clipsMap } = selectData(store.getState());
    const clipTime = getClipTime(selectClipData(clipId, clipsMap!));
    srPlayerRef.current?.seekTo(clipTime, 'seconds');
  }, []);

  return { srSelectClip, srSelectFile };
};

/* S E L E C T O R */

const selectData = (state: RootState) => {
  const { clipsMap, selector } = state.editor;
  return { clipsMap, selector };
};
